import React from 'react';
import ODropDownMenu from '../../../UI/DropDownMenu/ODropDownMenu';
import { icons } from '../../../../../shared/icons';
import { useTranslation } from 'react-i18next';

const GridOptions = ({
  children,
  handleOpenDialog,
  getEditData,
  opetPicture,
}) => {
  const { t, i18n } = useTranslation();
  const options = [
    {
      title: t('edit'),
      subtitle: t('edit'),
      path: 'profil',
      id: 1,
      icon: 'fas fa-pen',
      color: '#2f3a3f',
      onClick: () => getEditData(),
    },
    {
      title: t('buttons.delete'),
      subtitle: t('buttons.delete'),
      path: 'login',
      id: 2,
      icon: 'fas fa-trash',
      color: '#ff5552',
      onClick: () => handleOpenDialog(),
    },
  ];

  return (
    <div style={{ display: 'flex' }}>
      <ODropDownMenu align="end" position="anchor" options={options}>
        {children}
      </ODropDownMenu>
      <button className="header-options" onClick={opetPicture}>
        {icons.PICTURE_ICON}
      </button>
    </div>
  );
};

GridOptions.propTypes = {
  children: PropTypes.node.isRequired,
  handleOpenDialog: PropTypes.func.isRequired,
  getEditData: PropTypes.func.isRequired,
};

export default GridOptions;
